import { render, staticRenderFns } from "./RelatorioFormaPagamento.vue?vue&type=template&id=6630e270&"
import script from "./RelatorioFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./RelatorioFormaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports